module.exports = __webpack_public_path__ + "static/img/2.0f2cfcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/2.png
// module id = Z4jj
// module chunks = 0